import TemplateView from "../../TemplateView";
import {WorkflowStatusType} from "../../workflowStatus/constants";
import messageResource from "../../messageResource";
import {ValidationErrors} from "./constants";
import {EntityTextLimits} from 'constants'

export default class EditWorkflowStatusDialog extends TemplateView {
    constructor({
                    selectColorContent,
                    dialogFooter,
                    onNameChangedCb,
                    onHideCb = () => {}
                }) {
        super(null)

        this.state = {
            statusId: -1,
            statusType: WorkflowStatusType.OPEN,
            statusName: '',
            errors: []
        }


        this.components = {
            selectColorContent,
            dialogFooter
        }

        this.callbacks = {
            onNameChangedCb,
            onHideCb
        }

        this.onStatePropertyChanged('statusName', () => {this.nameField.val(this.state.statusName)})

        this.onStatePropertyChanged('errors', () => {this._updateErrors()})

    }

    templateHtml() {
        return '<div class="editWorkflowStatusDialog">' +
               '    <div class="content">' +
               '        <input class="nameField inputFieldWithPlaceholder" maxlength="<%=maxNameLength%>" placeholder="<%-statusNamePlaceholder%>"/>' +
               '        <div class="nameFieldErrorWrapper">' +
               '            <div class="nameFieldError"></div>' +
               '        </div>' +
               '    </div>' +
               '</div>'
    }

    templateModel() {
        return {
            maxNameLength: EntityTextLimits.MAX_WORKFLOW_STATUS_NAME
        }
    }

    messageKeys() {
        return {
            statusNamePlaceholder: "workflow_settings.status_name_placeholder"
        }
    }

    show() {
        super.show()
        this.nameField.focus()
    }

    hide() {
        super.hide()
        this.callbacks.onHideCb()
    }

    afterRender() {
        this.content = this.find('.content');
        this.components.selectColorContent.init(this.content)
        this.components.dialogFooter.init(this.getEl())
        this.nameField = this.find('.nameField');
        this.nameFieldError = this.find('.nameFieldError');

        this._subscribeForEvents()
    }

    _subscribeForEvents() {
        this.nameField.on('blur', () => {
            const val = this.nameField.val().trim()
            if (this.state.statusName !== val)
                this.callbacks.onNameChangedCb(val)
        })
    }

    _updateErrors() {
        this.nameField.removeClass('error')
        this.nameFieldError.hide()

        if (this.state.errors.includes(ValidationErrors.DUPLICATE_NAME_ERROR)) {
            this.nameField.addClass('error')
            this.nameFieldError.text(messageResource.getMessage('workflow_settings.errors.duplicate_name'))
            this.nameFieldError.show()
        }

        if (this.state.errors.includes(ValidationErrors.EMPTY_NAME_ERROR)) {
            this.nameField.addClass('error')
            this.nameFieldError.text(messageResource.getMessage('workflow_settings.errors.empty_name'))
            this.nameFieldError.show()
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/workflowSettings/EditWorkflowStatusDialog.js